import { render } from "./SzFormDetail.vue?vue&type=template&id=10104299&scoped=true"
import script from "./SzFormDetail.vue?vue&type=script&lang=ts"
export * from "./SzFormDetail.vue?vue&type=script&lang=ts"

import "./SzFormDetail.vue?vue&type=style&index=0&id=10104299&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-10104299"

export default script